// extracted by mini-css-extract-plugin
export default {"grid":"PresentersProfiles_grid__K7niG"};